const $$splitComponentImporter = () => import('/home/dylan/code/helldivers2-classes/packages/web/src/client/routes/wildcard.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/wildcard")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});